// ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: null };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true, error };
    }
  
    componentDidCatch(error, info) {
      console.error("Caught by ErrorBoundary:", error, info);
    }
  
    render() {
      if (this.state.hasError) {
        // Use fallback UI passed as prop
        if (this.props.fallback) return this.props.fallback;
  
        // Or default fallback
        return <h4 className='text-center'>Something went wrong.</h4>;
      }
  
      return this.props.children;
    }
  }
  

export default ErrorBoundary;
